if (!customElements.get('hoobro-flash-sale')) {
  customElements.define('hoobro-flash-sale', class extends HTMLElement {
    static get observedAttributes() {
      return ['data-campaign-id', 'data-duration-days', 'data-duration-hours', 'data-duration-minutes', 'data-loop-mode', 'data-cycle-limit'];
    }

    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.countdown = this.querySelector('.hb-flash-sale__countdown');
      this.status = this.querySelector('.hb-flash-sale__status');
      this.cells = Object.fromEntries(Array.from(this.querySelectorAll('[data-time]')).map(cell => [cell.dataset.time, cell]));
      document.addEventListener('visibilitychange', () => this.updateCountdown(), { signal: this.controller.signal });
      this.initializeCountdown();
    }

    attributeChangedCallback() {
      if (this.controller) this.initializeCountdown();
    }

    initializeCountdown() {
      const days = Number(this.dataset.durationDays);
      const hours = Number(this.dataset.durationHours);
      const minutes = Number(this.dataset.durationMinutes);
      this.duration = (days * 86400 + hours * 3600 + minutes * 60) * 1000;
      this.mode = this.dataset.loopMode;
      this.limit = this.mode === 'once' ? 1 : Number(this.dataset.cycleLimit);
      this.valid = [days, hours, minutes].every(value => Number.isInteger(value) && value >= 0)
        && days <= 30 && hours <= 23 && minutes <= 59 && this.duration > 0
        && ['infinite', 'count', 'once'].includes(this.mode)
        && (this.mode === 'infinite' || Number.isInteger(this.limit) && this.limit >= 1 && this.limit <= 30);
      if (this.valid) {
        const sectionId = this.closest('.shopify-section')?.id || this.id || 'flash-sale';
        this.storageKey = 'hoobro-flash-sale-v1:' + JSON.stringify([sectionId, this.dataset.campaignId || 'flash-sale', this.duration, this.mode, this.mode === 'count' ? this.limit : 0]);
        this.startedAt = this.restoreStartTime();
      }
      this.updateCountdown();
    }

    restoreStartTime() {
      const now = Date.now();
      if (window.Shopify?.designMode) {
        this.editorStarts ||= new Map();
        if (!this.editorStarts.has(this.storageKey)) this.editorStarts.set(this.storageKey, now);
        return this.editorStarts.get(this.storageKey);
      }
      for (const storageName of ['localStorage', 'sessionStorage']) {
        try {
          const storage = window[storageName];
          const saved = JSON.parse(storage.getItem(this.storageKey) || 'null');
          if (Number.isFinite(saved?.startedAt) && saved.startedAt > 0 && saved.startedAt <= now) return saved.startedAt;
          storage.setItem(this.storageKey, JSON.stringify({ startedAt: now }));
          return now;
        } catch {}
      }
      this.memoryStarts ||= new Map();
      if (!this.memoryStarts.has(this.storageKey)) this.memoryStarts.set(this.storageKey, now);
      return this.memoryStarts.get(this.storageKey);
    }

    updateCountdown() {
      clearTimeout(this.timer);
      this.timer = null;
      if (!this.isConnected) return;
      const elapsed = this.valid ? Math.max(0, Date.now() - this.startedAt) : 0;
      const completed = this.valid ? Math.floor(elapsed / this.duration) : 0;
      const active = this.valid && (this.mode === 'infinite' || completed < this.limit);
      const remaining = active ? this.duration - elapsed % this.duration : 0;
      const editor = Boolean(window.Shopify?.designMode);
      const wasHidden = this.hidden;
      this.hidden = !active && !editor;
      const section = this.closest('.shopify-section');
      if (section) section.hidden = this.hidden;
      this.dataset.countdownState = active ? 'active' : this.valid ? 'expired' : 'invalid';
      this.countdown.hidden = !active;
      this.status.hidden = !editor || active;
      this.status.textContent = this.status.hidden ? '' : this.dataset[this.valid ? 'statusExpired' : 'statusInvalid'] || '';
      if (wasHidden && !this.hidden) this.querySelectorAll('slider-component').forEach(slider => slider.resetPages?.());
      if (!active) return;
      const total = Math.ceil(remaining / 1000);
      const values = { days: Math.floor(total / 86400), hours: Math.floor(total % 86400 / 3600), minutes: Math.floor(total % 3600 / 60), seconds: total % 60 };
      for (const [key, value] of Object.entries(values)) this.cells[key].textContent = String(value).padStart(2, '0');
      const dayPart = this.querySelector('.hb-flash-sale__day-part');
      if (dayPart) dayPart.hidden = values.days === 0;
      if (!document.hidden) this.timer = setTimeout(() => this.updateCountdown(), Math.min(1000, remaining));
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.timer = null;
      this.controller?.abort();
      this.controller = null;
    }
  });
}
